export const routes = {
  Dashboard: "/",
  AllPlans: "/plans",
  MyPlans: "/myplans",
  Library: "/library",
  CardDetails: ":cardId",
  sectionDetails: ":secId",
  PlanDetails: "/plandetails/:id",
  UserDashboard: "/userDashboard",
  CorporateDashboard: "/CorporateDashboard",
  MyPlanDetails: "/myplandetails/:id",
  IndividualProperty: "/property/:inncode",
  LibraryHallSearch: "/library/search",
  FunctionalArea: "/functionalArea/:id",
  PlanProgress: "/planProgress",
  UserView: "/userview/:hltId",
  MyLists: "/myLists",
  ProgressInfo: "/progressInfo/:type/:listId",
  AdminConsole: "/adminconsole",
  EditPermission: "/editPermission",
  ManageSuggestions: "/managesuggestions",
  Feedback: "/feedback",
  EditFeedback: "/editfeedback"
};
